import React, { useState, useEffect, useLayoutEffect } from "react";
import { FaBookOpen } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { showError } from "../../utils/toast";
import './LoginPage.css';
import CryptoJS from 'crypto-js'; 
// import axios from 'axios';

export default function LoginPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('keys'); 
  const [isLoader, setIsLoader] = useState(() => {
  const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('sso_redirect') === 'true';
  });
  const [publicKey, setPublicKey] = useState("");
  const [privateKey, setPrivateKey] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [businesses, setBusinesses] = useState([]); 
  const [showBusinessList, setShowBusinessList] = useState(false);
  const singleLoginRedirectUrl = process.env.REACT_APP_SINGLELOGIN_FE_REDIRECT_URL;
  const singleLoginBEUrl = process.env.REACT_APP_SINGLELOGIN_BE_REDIRECT_URL;
  const moduleLink = process.env.REACT_APP_FE_MODULE_URL;
  const redirectLink = process.env.REACT_APP_FE_MODULE_URL;
  const API_URL = process.env.REACT_APP_API_URL;
  // const redirectLink = process.env.REACT_APP_FE_MODULE_URL;
  const aesSalt = process.env.REACT_APP_AES_SALT;

const encryptPassword = (plaintext) => {
  const password = CryptoJS.AES.encrypt(plaintext, aesSalt).toString();
  return password
};
const handleBusinessSelect = async (business) => {
  try {
    setIsLoading(true);
    
    // Get the token from localStorage
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    // Make the API call to get module authentication token
    const response = await fetch(`${singleLoginBEUrl}/users/module-auth`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        moduleUrl: moduleLink,
        businessId: business.id
      })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData?.message || errorData?.error || `Module authentication failed`);
    }

    const data = await response.json();
    
    // Get the module auth token from response
    const moduleAuthToken = data.token;
    
    // if (!moduleAuthToken) {
    //   throw new Error('No token received from module authentication');
    // }

    // Store the new token in localStorage
    localStorage.setItem('token', moduleAuthToken);
    
    // Navigate to book list
    navigate('/book-list');
    
  } catch (error) {
    console.error('Business selection failed:', error);
    showError(error.message || 'An unexpected error occurred');
  } finally {
    setIsLoading(false);
  }
};
 
  const decodeJWT = (token) => {
    try {
      const parts = token.split('.');
      // if (parts.length !== 3) {
      //   throw new Error('Invalid JWT token');
      // }
      
      const payload = parts[1];
      const decodedPayload = JSON.parse(atob(payload));
      
      return decodedPayload;
    } catch (error) {
      console.error('Error decoding JWT:', error);
      return null;
    }
  };

useLayoutEffect(() => {
  const isPopup = window.opener !== null;
  const trustedHostEnv = process.env.REACT_APP_SINGLELOGIN_HOST || '';

  const trustedHost = trustedHostEnv.trim().toLowerCase(); // e.g. localhost:3000

  let referrerHost = '';
  if (document.referrer) {
    try {
      referrerHost = new URL(document.referrer).host.trim().toLowerCase();
    } catch (_) {
      referrerHost = '';
    }
  }

  let isTrustedReferrer = false;
  if (trustedHost) {
    // Fallback: if no trusted referrer URL is set, accept referrers matching trustedHost
    isTrustedReferrer = referrerHost === trustedHost;
  }

  if (isPopup && (isTrustedReferrer)) {
    setIsLoader(true);
  }
}, []);

useEffect(() => {
  const handleMessage = async (event) => {
    const { type, publicKey, privateKey, source } = event.data || {};

    if (type === "SSO_LOGIN" && source === "sso_redirect") {
      setIsLoading(true);
      await loginWithKeys(publicKey, privateKey);
    }
  };

  window.addEventListener("message", handleMessage);
  return () => window.removeEventListener("message", handleMessage);
}, []);

// Handle token-based postMessage from trusted SingleLogin FE redirect
useEffect(() => {
  const handleMessage = (event) => {
    try {
      const redirectUrl = process.env.REACT_APP_SINGLELOGIN_FE_REDIRECT_URL;
      
      // if (!redirectUrl) {
      //   console.error('REACT_APP_SINGLELOGIN_FE_REDIRECT_URL is not defined');
      //   return;
      // }
      
      let expectedOrigin;
      try {
        const urlObj = new URL(redirectUrl);
        expectedOrigin = urlObj.origin;
      } catch (error) {
        console.error('Invalid URL format:', redirectUrl);
        return;
      }
      
      if (event.origin !== expectedOrigin) {
        console.warn('Message from untrusted origin:', event.origin);
        return;
      }
      
      let data;
      if (typeof event.data === 'string') {
        try { data = JSON.parse(event.data); } catch { data = undefined; }
      } else if (typeof event.data === 'object') {
        data = event.data;
      } else {
        console.warn('Unknown message format:', event.data);
        return;
      }
      
      if (data?.token) {
        const decodedToken = decodeJWT(data.token);
        try {
          localStorage.setItem('token', data.token);
        } catch (_) {}
        navigate('/book-list');
      }
    } catch (e) {
      console.warn("Error processing message:", e);
    }
  };

  window.addEventListener("message", handleMessage);
  return () => window.removeEventListener("message", handleMessage);
}, [navigate]);

  const loginWithKeys = async (publicKey, privateKey) => {
    setIsLoading(true);
    try {
      const response = await fetch(`${singleLoginBEUrl}/users/login-with-keys`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          publicKey: publicKey,
          privateKey: privateKey,
          moduleUrl: moduleLink,
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData?.message || errorData?.error || `Authentication failed`);
      }

      const data = await response.json();

      const token = data.token || data.access_token;
      if (token) {
        localStorage.setItem('token', token);
        try {
          const decoded = decodeJWT(token);
        } catch (_) {}
        navigate('/book-list');
      } else {
        throw new Error('No token received from server');
      }

    } catch (error) {
      console.error('Login with keys failed:', error);
      setIsLoader(false); // Only hide loader on error
      showError(error.message || 'An unexpected error occurred');
    }finally {
      setIsLoading(false); 
    }
  };


  const handleSingleLoginRedirect = () => {
    const width = 500;
    const height = 600;
    const left = 0; 
    const top = 0;  

    window.open(
      `${singleLoginRedirectUrl}/?moduleurl=${moduleLink}&redirecturl=${redirectLink}`, 
      "SingleLoginPopup", 
      `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars`
    );
  };

  const handleSingleLogin = async (e) => {
    e.preventDefault();
    if (activeTab === 'keys') {
      if (!publicKey || !privateKey) {
        showError("Please fill in all fields");
        return;
      }
      loginWithKeys(publicKey, privateKey);
      return;
    }

    if (activeTab === 'email') {
        if (!email || !password) {
      showError("Please fill in all fields");
      return;
    }
    
    try {
          setIsLoading(true);
          const [idToken, businessesList] = await loginWithEmailPassword(email, password);
          if (idToken) {
           localStorage.setItem('token', idToken);
          }
          setBusinesses(businessesList); 
          setShowBusinessList(true);
        } catch (error) {
          showError(error.message || 'An unexpected error occurred');
        } finally {
          setIsLoading(false);
        }
      }
  };

 const loginWithEmailPassword = async (email, password) => {
  try {
    setIsLoading(true);
     // Encrypt the password before sending
      const encryptedPassword = encryptPassword(password);
      
      const response = await fetch(`${singleLoginBEUrl}/users/login-with-email-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          password: encryptedPassword,
          moduleUrl: moduleLink
        }),
      });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData?.message || errorData?.error || `Authentication failed`);
    }

    const data = await response.json();
    console.log('API Response:', data);
    
    // Check if businesses are returned in the response
    if (data.businessesList) {
      return [data.idToken, data.businessesList]; 
    } else {
      throw new Error('No businesses received from server');
    }

  } catch (error) {
    console.error('Email login failed:', error);
    throw error;
  } finally {
    setIsLoading(false);
  }
};

  if (isLoader) {
    return (
      <div className="loader-container">
        <div className="loader-content">
          <FaBookOpen className="loader-icon" />
          <h2 className="loader-title">Completing Secure Login</h2>
          <div className="loader-spinner"></div>
          <p className="loader-subtitle">Please wait while we connect you</p>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(to right, #dfe6f1, #f8f9fa)",
      }}
    >
      <div
        style={{
          maxWidth: "420px",
          width: "100%",
          background: "white",
          padding: "35px",
          borderRadius: "12px",
          boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <FaBookOpen
            style={{ fontSize: "50px", color: "#00008B", marginRight: "10px" }}
          />
          <span style={{ fontSize: "36px", fontWeight: 200 }}>
            Book<span style={{ color: "#86c5da" }}>List</span> App
          </span>
        </div>

        

        {/* Business selection view for Credentials tab */}
        {activeTab === 'email' && showBusinessList ? (
          <div>
            {/* Please Select a Business Subtitle */}
            <div className='pb-8 pb-lg-15'>
            <h2 style={{ textAlign: "center", marginBottom: "16px", color: "#00008B", fontWeight: 500 }}>
              Select Your Business
            </h2>
            </div>

            {/* Business Cards */}
            <div className='row justify-content-center' style={{ display: 'flex', flexWrap: 'wrap' }}>
              {businesses.map((business) => (
                <div key={business.id} className='col-md-6 col-xl-6 mb-6' style={{ width: '100%', marginBottom: '12px' }}>
                  <div 
                    className='card card-custom bg-white shadow-sm business-card'
                    onClick={() => handleBusinessSelect(business)}
                    style={{ 
                      cursor: 'pointer',
                      border: '1px solid #e0e0e0',
                      borderRadius: '8px',
                      transition: 'all 0.3s ease',
                      maxWidth: '400px',
                      margin: '0 auto'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                    }}
                  >
                    <div className='card-body d-flex align-items-center justify-content-center p-8' style={{ padding: '24px' }}>
                      <div className='d-flex flex-column text-center'>
                        <span className='text-dark font-weight-bolder font-size-h5 mb-0' style={{ fontSize: '1rem', fontWeight: '600' }}>
                          {business.name}
                        </span>
                        {business.email && (
                          <div className='text-muted font-size-sm mt-1' style={{ marginTop: '4px', color: '#64748b' }}>
                            {business.email}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
        <form onSubmit={handleSingleLogin}>
          <h2 style={{ textAlign: "center", marginBottom: "20px", color: "#00008B", fontWeight: 500 }}>
            {activeTab === 'keys' ? 'SingleLogin Authentication (Keys)' : 'SingleLogin Authentication (Email)'}
          </h2>

          {/* Tabs (placed BELOW heading as requested) */}
          <div style={{ display: 'flex', marginTop: '0px', marginBottom: '20px' }}>
            <button
              onClick={() => setActiveTab('keys')}
              type="button"
              style={{
                flex: 1,
                padding: '13px',
                border: 'none',
                background: activeTab === 'keys' ? '#00008B' : '#f8fafc',
                color: activeTab === 'keys' ? '#ffffff' : '#0f172a',
                border: activeTab === 'keys' ? '1px solid #00008B' : '1px solid #e5e7eb',
                cursor: 'pointer',
                fontWeight: 600,
                borderRadius: '8px 0px 0px 8px',
                fontSize: '15px',
              }}
            >Keys</button>
            <button
              onClick={() => setActiveTab('email')}
              type="button"
              style={{
                flex: 1,
                padding: '13px',
                border: 'none',
                background: activeTab === 'email' ? '#00008B' : '#f8fafc',
                color: activeTab === 'email' ? '#ffffff' : '#0f172a',
                border: activeTab === 'email' ? '1px solid #00008B' : '1px solid #e5e7eb',
                cursor: 'pointer',
                fontWeight: 600,
                borderRadius: '0px 8px 8px 0px',
                fontSize: '15px',
              }}
            >Credentials</button>
          </div>

          {activeTab === 'keys' && (
            <>
              <div style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
                <label style={{ marginBottom: "5px", fontWeight: 500, color: "#808080" }}>
                  Public Key
                </label>
                <input
                  type="text"
                  value={publicKey}
                  onChange={(e) => setPublicKey(e.target.value)}
                  placeholder="Enter Public Key"
                  style={{
                    padding: "12px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
                <label style={{ marginBottom: "5px", fontWeight: 500, color: "#808080" }}>
                  Private Key
                </label>
                <input
                  type="password"
                  value={privateKey}
                  onChange={(e) => setPrivateKey(e.target.value)}
                  placeholder="Enter Private Key "
                  style={{
                    padding: "12px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
            </>
          )}

          {activeTab === 'email' && (
            <>
              <div style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
                <label style={{ marginBottom: "5px", fontWeight: 500, color: "#808080" }}>
                  Email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter Email"
                  style={{
                    padding: "12px",
                    borderRadius: "6px",
                    border: "1px solid " + (email ? '#ccc' : '#fca5a5'),
                  }}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
                <label style={{ marginBottom: "5px", fontWeight: 500, color: "#808080" }}>
                  Password
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter Password"
                  style={{
                    padding: "12px",
                    borderRadius: "6px",
                    border: "1px solid " + (password ? '#ccc' : '#fca5a5'),
                  }}
                />
              </div>
            </>
          )}

          <button
            type="submit"
            disabled={isLoading}
            style={{
              backgroundColor: isLoading ? "#ccc" : "#00008B",
              color: "white",
              width: "100%",
              padding: "12px",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: isLoading ? "not-allowed" : "pointer",
              marginBottom: "12px",
            }}
          >
            {isLoading ? "Authenticating..." : "Login"}
          </button>

          <button
            type="button"
            onClick={handleSingleLoginRedirect}
            style={{
              backgroundColor: "#86c5da",
              color: "white",
              width: "100%",
              padding: "12px",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Sign in with SingleLogin.io
          </button>
        </form>
        )}
      </div>
    </div>
  );
} 